import { InputAdornment, TextField } from '@mui/material';
import { ReactNode } from 'react';
import { useState } from 'react';
export default function MemreInput({
  fullWidth = true,
  label,
  submitButton,
  onValueChange,
  sx = {},
  value = '',
  onBlur,
}: {
  value?: string;
  label: string;
  fullWidth?: boolean;
  submitButton?: ReactNode;
  onValueChange?: any;
  sx?: any;
  onBlur?: (e: any) => void;
}) {
  const [updatedValue, setValue] = useState(value);

  const handleChange = (e) => {
    setValue(e.target.value);
    if (onValueChange) {
      onValueChange(e.target.value);
    }
  };

  return (
    <TextField
      fullWidth={fullWidth}
      label={label}
      sx={sx}
      onBlur={onBlur}
      value={updatedValue}
      onChange={handleChange}
      InputProps={
        submitButton
          ? {
              endAdornment: <InputAdornment position="end">{submitButton}</InputAdornment>,
            }
          : undefined
      }
    />
  );
}
